import { render } from "./OrganisationSearchCriteria.vue?vue&type=template&id=06b6cbd2"
import script from "./OrganisationSearchCriteria.vue?vue&type=script&lang=js"
export * from "./OrganisationSearchCriteria.vue?vue&type=script&lang=js"

import exportComponent from "/home/rampa/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__